import { Component } from '@angular/core';
import { sidemenuData } from '../../providers/dummy-data';
import { RouterModule } from '@angular/router';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  menus:any[]=sidemenuData;

}
